import type { Record } from "~/tools/record";
export type IconSize = "tiny" | "xsmall" | "small" | "default" | "large";

const iconSizes: Record<IconSize, number> = {
	tiny: 18,
	xsmall: 24,
	small: 26,
	default: 32,
	large: 48,
};

export const getSizeForIcon = (size: IconSize = "default"): number => iconSizes[size];
